import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { StoryblokCdnPipe } from '../../../storyblok/pipes/storyblok-cdn.pipe';

@Component({
  selector: 'app-link-list-item',
  templateUrl: './link-list-item.component.html',
  styleUrls: ['./link-list-item.component.scss'],
  standalone: true,
  imports: [NgIf, NgTemplateOutlet, RouterLink, SvgComponent, StoryblokCdnPipe],
})
export class LinkListItemComponent {
  @Input() image: string;
  @Input() externalLink: string;
  @Input() link: string | string[];
  @Input() fragment: string;
  @Input() query: Params;
  @Input() title: string;
  @Input() description: string;
  @Input() imageStyle: 'plain' | 'round';
  @Input() size: 'normal' | 'small' | 'tiny' = 'normal';
}
